import images from "./images";

const services = [
    {
        image: `${images.services_img_1}`,
        title: "Panama Canal",
        paragraph: "Our shuttle service offers safe and efficient rides to various destinations, ensuring you reach your destination comfortably and on time."
    },
    {
        image: `${images.services_img_2}`,
        title: "Panama City Tours",
        paragraph: "Discover the vibrant essence of our city with an unforgettable guided tour, where history meets modern charm in every corner."
    },
    {
        image: `${images.services_img_3}`,
        title: "Shopping Tour",
        paragraph: "Embark on a thrilling shopping spree in Panama City and indulge in a day filled with retail therapy and exploration."
    },
    {
        image: `${images.services_img_4}`,
        title: "Airport Ride",
        paragraph: " Will be a stunning stretch sand. After some time relaxing by the waves, we’ll head to a local beachside café to enjoy fresh seafood and refreshing drinks."
    },
    {
        image: `${images.services_img_5}`,
        title: "Gamboa Trails",
        paragraph: "Discover the beauty of avian life with our bespoke birdwatching tours, crafted specifically for passionate enthusiasts like you."
    },
    {
        image: `${images.services_img_6}`,
        title: "San Blas Tour",
        paragraph: "This beautiful archipelago of 378 islands is located in the North of Panama connected to the Caribbean Sea."
    },
];

const works = [
    {
        image: `${images.work_img_1}`
    },
    {
        image: `${images.work_img_2}`
    },
    {
        image: `${images.work_img_3}`
    },
    {
        image: `${images.work_img_4}`
    },
    {
        image: `${images.work_img_5}`
    },
    {
        image: `${images.work_img_6}`
    },
];

const work_process = [
    {
        title: "Sketch",
        paragraph: "Nunc sodales lacus nec felis suscipit dictum"
    },
    {
        title: "Design",
        paragraph: "Nunc sodales lacus nec felis suscipit dictum"
    },
    {
        title: "Develop",
        paragraph: "Nunc sodales lacus nec felis suscipit dictum"
    },
    {
        title: "End-Product",
        paragraph: "Nunc sodales lacus nec felis suscipit dictum"
    },
];

const about_stats = [
    {
        image: `${images.stat_img_1}`,
        value: "600+",
        title: "Tourist"
    },
    {
        image: `${images.stat_img_2}`,
        value: "150",
        title: "Tours"
    },
    {
        image: `${images.stat_img_3}`,
        value: "1287",
        title: "Work Hours"
    },
    {
        image: `${images.stat_img_4}`,
        value: "100%",
        title: "On Time"
    },
];

const testimonials = [
    {
        name: "Lelia Merritt",
        post: "Toronto, CA",
        paragraph: "Traveling with GM Transfer's private transportation was a game-changer for our trip. From the moment we were picked up at the airport, everything was smooth and enjoyable. "
    },
    {
        name: "John Huston",
        post: "New York, USA",
        paragraph: "Our experience with GM Transfer's private transportation was exceptional. We loved the personalized service and flexibility it offered. "
    },
    {
        name: "Jennifer Narciso",
        post: "Lima,Peru",
        paragraph: "GM Transfer's private transportation service provided us with a warm welcome to Panama. Our driver greeted us with a friendly smile and shared fascinating insights about the local culture and wildlife as we traveled."
    },
]

const logos = [
    {
        image: `${images.logo_img_1}`
    },
    {
        image: `${images.logo_img_2}`
    },
    {
        image: `${images.logo_img_3}`
    },
    {
        image: `${images.logo_img_4}`
    },
    {
        image: `${images.test_img_5}`
    },
    {
        image: `${images.test_img_6}`
    },
];

export {services, works, work_process, about_stats, testimonials, logos};
